module.exports = __webpack_public_path__ + "static/media/appstore-api-step-4.77199393.png";